__turbopack_context__.v({
  "authFallbackTileDescription": "articlesTiles-module-scss-module__Qtzjva__authFallbackTileDescription",
  "tile": "articlesTiles-module-scss-module__Qtzjva__tile",
  "unAuthFallbackTileDescription": "articlesTiles-module-scss-module__Qtzjva__unAuthFallbackTileDescription",
  "wrapper": "articlesTiles-module-scss-module__Qtzjva__wrapper",
});
